import area from "./area";
import unit from "./unit";
import pushStrategy from "./pushStrategy";
import log from "./log";
import url from "./url";
import user from "./user";
import menu from "./menu";
import role from "./role";
import permission from "./permission";
import pushMessage from "./pushMessage";
import product from "./product";
import dict from "./dict";
import industryCategory from "./industryCategory";
import about from "./about";
import organ from "./organ";
import document from "./document"
import planePicture from "./planePicture";
import telecom from "./telecom";
import systemNotice from "./systemNotice";
import auxiliary from "./auxiliary";

export default {
    area, unit, pushStrategy, log, url, user, menu, role,
    permission, pushMessage, product, dict, industryCategory, about,
    organ, planePicture, document, telecom, systemNotice, auxiliary
}